// bao migrate skip
import TabPage from "./../factories/tab-page";
import "./../services/bao-menu";
import "./../bindings/validate";
import "./../bindings/bao-searcher";
import "./../bindings/bao-date-time-picker";
import "./../bindings/bao-date-time-box";
import "./../services/bao-router";
import "./../factories/translate-dialog";
import BaseViewModel from "./../factories/base-view-model2";
import * as ko from "knockout";
import Bao from "./../services/bao-service";
import BaoDialog from "./../factories/bao-dialog";
import TranslateDialogViewModel from "./../factories/translate-dialog";
class QualificationViewModel extends BaseViewModel {
    private Name: KnockoutComputed<string>;
    private Name1: KnockoutObservable<string> = ko.observable("");
    private Name2: KnockoutObservable<string> = ko.observable("");
    private Name3: KnockoutObservable<string> = ko.observable("");
    private Name4: KnockoutObservable<string> = ko.observable("");
    private Name5: KnockoutObservable<string> = ko.observable("");

    public constructor(tabPage: TabPage) {
        super(tabPage);
        this.Name = ko.pureComputed<string>({
            read: () => {
                switch (Bao.Session.Language.LanguageIndex()) {
                    case 1:
                        return this.Name1();
                    case 2:
                        return this.Name2();
                    case 3:
                        return this.Name3();
                    case 4:
                        return this.Name4();
                    case 5:
                        return this.Name5();
                }
            },
            write: (value) => {
                switch (Bao.Session.Language.LanguageIndex()) {
                    case 1:
                        this.Name1(value);
                        break;
                    case 2:
                        this.Name2(value);
                        break;
                    case 3:
                        this.Name3(value);
                        break;
                    case 4:
                        this.Name4(value);
                        break;
                    case 5:
                        this.Name5(value);
                        break;
                }
            }
        });
    }
    Translate() {
        var translateDialog = new TranslateDialogViewModel(this.Name1, this.Name2, this.Name3, this.Name4, this.Name5);
        translateDialog.Open().then(() => {
        });
    }
    ;
    public CompleteCheck(): JQueryPromise<boolean> | boolean {
        var completed: boolean;
        completed = true;
        if (this.Name() === null || this.Name() === "") {
            completed = false;
        }
        if (!completed) {
            var baoDialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return completed;
    }
    InitUrl(): string {
        return "Qualification/Init";
    }

    init() {
        return $.when(super.init(), super.InitTabController()).then(() => {
            const tabQualifications = new TabPage("QualificationPerson");
            tabQualifications.IsClosable(false);
            tabQualifications.Url("QualificationPerson");
            tabQualifications.AutoSelect = true;
            this.TabController.AddTab(tabQualifications);
        });
    }
}
export default QualificationViewModel;